'use client';

import { ForumBoardClient } from '@/platform/forum/ForumBoardClient';
import { HostHelpFeedCard } from '@/platform/hostgrowth/HostHelpFeedCard';
import { brandConfig } from '@/config/brand';

/** Communio Social tenant home — repo default (paydirt vertical swaps page.paydirt.tsx). */
export default function CommunioHomePage() {
  return (
    <ForumBoardClient
      title="Community feed"
      description={brandConfig.forum.description}
      subSlug={brandConfig.forum.defaultSubSlug}
      beforeFeed={<HostHelpFeedCard />}
    />
  );
}
